// ============
// Blog Filters
$(document).ready(function () {

    // Auto submit form on filter select change
    $('.blog-category-filter select, .blog-tag-filter select').change(function (e) {
        updateBlogFilters();
    });

    loadBlogFilters();
});

function blogGetParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function loadBlogFilters() {
    var queries = {};
    $.each(document.location.search.substr(1).split('&'), function (c, q) {
        var i = q.split('=');
        if (i.length > 1) {
            queries[i[0].toString()] = i[1].toString();
        }
    });

}

function updateBlogFilters() {
    var tag = 'tag=' + $('.blog-tag-filter select option:checked').map(function () {
        return this.value.match(/\d+/g);
    }).get();
    var category = 'category=' + $('.blog-category-filter select option:checked').map(function () {
        return this.value.match(/\d+/g);
    }).get();

    console.log(tag);
    console.log(category);

    if (document.querySelector(".blog-category-filter select").classList.contains("blog-view") || document.querySelector(".blog-tag-filter select").classList.contains("blog-view")) {
        var url = [location.protocol, '//', location.host, "/Blog/Search"].join('');
    } else {
        var url = [location.protocol, '//', location.host, location.pathname].join('');
    }

    var searchtext = blogGetParameterByName('searchtext');
    if (searchtext) {
        searchtext = 'searchtext=' + searchtext;
    }
    var searchmode = blogGetParameterByName('searchmode');
    if (searchmode) {
        searchmode = 'searchmode=' + searchmode;
    }

    var query = '';
    query = [tag, category, searchtext, searchmode].filter(Boolean).join('&');

    window.location.href = url + '?' + query;
}

function searchBlog(e) {
    var t = document.getElementById(e);
    t.value && (window.location = "/Blog/Search?searchtext=" + t.value + "&searchmode=allwords")
}

// language selecter event handler
document.querySelectorAll('select[name="search-culture-selector"]').forEach(sel => {
    sel.addEventListener('change', function () {
        if (this.value) {
            window.location.href = this.value;
        }
    });
});